import React from 'react';
import styled from 'styled-components';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Container = styled.div`
  width: 100%;
  max-width: 800px;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  flex: 1;
  overflow-y: auto; /* 🔹 Hace scrolleable solo el contenido */
  padding-bottom: 20px; /* 🔹 Espacio para la botonera */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  background-color: white;
  padding: 15px 0;
  width: 100%;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  position: relative;
`;

const PageContainer = ({ children, onBack, onNext, nextDisabled, showFooterButtons = true }) => {
  return (
    <PageWrapper>
      <Container>
        <ContentWrapper>{children}</ContentWrapper>
        {showFooterButtons && (
          <ButtonContainer>
            <button type="button" className="btn-secondary" onClick={onBack}>
              Volver
            </button>
            <button type="button" className="btn-cyan" onClick={onNext} disabled={nextDisabled}>
              Siguiente
            </button>
          </ButtonContainer>
        )}
      </Container>
    </PageWrapper>
  );
};

export default PageContainer;
